export enum ReferrallQueryKeys {
  GET_REFERRAL_DETAIL = 'GET_REFERRAL_DETAIL',
  GET_REFERRAL_TRANSACTION = 'GET_REFERRAL_TRANSACTION',
  EXPORT_REFERRAL_TRANSACTION = 'EXPORT_REFERRAL_TRANSACTION',
}
